import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  const companyInfo = [
    { label: '会社名', value: '株式会社飛翠' },
    { label: '設立', value: '2024年10月' },
    { label: '資本金', value: '1,000,000円' },
    { label: '所在地', value: '神奈川県横浜市中区石川町1丁目13番地2 エネクル横浜元町テラス1F' },
    { label: '従業員数', value: '6名（2025年11月現在 業務委託含む）' },
    { label: '電話番号', value: '準備中' },
    { label: '対応エリア', value: '一都三県（東京都、神奈川県、埼玉県、千葉県）' },
    { label: '営業時間', value: '9:00〜18:00（年中無休）' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/b658ec44643312be6643ec4141ccd581.png)',
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50"></div>
        
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-serif text-white mb-4">会社概要</h1>
          <p className="text-lg text-white/90">About Us</p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">企業理念</h2>
            <p className="text-xl text-gray-700 leading-relaxed font-medium">
              お客様の暮らしに寄り添い、<br className="md:hidden" />信頼される企業であり続ける
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#A7D676]/10 to-[#76C7E1]/10 rounded-lg p-8 md:p-12 mb-16">
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              飛翠は、関東圏で暮らしを支えるトータルサポート企業です。出張買取、家財撤去、ハウスクリーニング、家電修理、リフォームなど、お客様の日常生活に関わる幅広いサービスを提供しています。
            </p>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              私たちは「信頼」「誠実」「迅速」を大切にし、一つひとつの仕事に真摯に向き合っています。お客様の大切な住まいや財産を扱う責任を深く認識し、常に最高のサービスを提供できるよう努めています。
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              どんな小さなお困りごとでも、お気軽にご相談ください。経験豊富なスタッフが、丁寧かつ迅速に対応いたします。
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-gradient-to-br from-[#76C7E1]/5 to-[#A7D676]/5">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-4">代表メッセージ</h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            <div className="lg:col-span-1">
              <div className="rounded-lg shadow-lg w-full h-[500px] bg-gray-100 flex items-center justify-center">
                <span className="text-gray-400 text-lg font-medium tracking-widest">NO IMAGE</span>
              </div>
              <div className="text-center mt-6">
                <p className="text-lg font-bold text-gray-800">代表取締役</p>
                <p className="text-2xl font-serif text-gray-800 mt-2">及川 貴史</p>
              </div>
            </div>

            <div className="lg:col-span-2">
              <div className="bg-white rounded-lg p-8 shadow-md">
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  私たちのホームページをご覧いただき、誠にありがとうございます。代表取締役の及川貴史です。
                </p>
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  当社は「臨機応変」を使命に、事業活動を行ってまいりました。
                </p>
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  昨今の世の中はIT技術が加速度的に進化し、目まぐるしく変化する時代です。そんな世の中において大切にしたいことは「時代の変化に対応し続けること」
                </p>
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  ダーウィンの進化論にもあるように生き残ることができた生物は"変化に対応できた生き物のみ"
                </p>
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  しかし、いつの時代も変わらないのは「人と人との信頼関係」だと考えています。
                </p>
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  お客様一人ひとりの課題に真摯に向き合い、表面的な解決ではなく、本質的な価値提供と問題可決を行うこと。それこそが企業として長期的に成長し、社会に必要とされ続けるための唯一の方法だと信じています。
                </p>
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  当社はスピードと柔軟性を強みに、常に現場視点を大切にしながら、期待を超える成果を目指して挑戦を続けてまいります。
                </p>
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  小さなご縁を大切にし、大きな信頼へと育てていくそんな企業でありたいと考えています。
                </p>
                <p className="text-base text-gray-700 leading-relaxed">
                  今後とも、変わらぬご支援とご指導を賜りますよう、心よりお願い申し上げます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-4">会社情報</h2>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <table className="w-full">
              <tbody>
                {companyInfo.map((item, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="px-6 py-4 text-sm font-bold text-gray-800 w-1/3 border-b border-gray-200">
                      {item.label}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700 border-b border-gray-200">
                      {item.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
